import Dropdown from 'sma.admin/components/dropdowns/dropdown';
let ajax = require('sma.common/ajax');
var { Confirm } = require('sma.common/components/modals');

var surveyStart = function () {
	$('.sma-js-reset-task').on('click', function() {
		new Confirm(
			gettext('This will reset the task'),
			gettext('Are you sure you want to continue?'),
			function () { 
				$('#form-reset').click();
			}
		);

		return false;

	});
}

module.exports = surveyStart;
